// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"97d28298","843":"5c157d0c","990":"b6cbc5aa"}[chunkId] + ".chunk.css";
};